import { ref, setLocale, string } from 'yup'

export const PT_BR_LOCALE = {
  mixed: {
    default: 'Valor inválido',
    required: 'Campo obrigatório',
    defined: 'Campo obrigatório',
    notNull: 'Campo obrigatório',
    oneOf: 'Selecione uma opção válida',
    notOneOf: 'Valor não permitido',
    notType: 'Valor inválido'
  },
  string: {
    length: ({ length }: { length: number }) => `Use exatamente ${length} caracteres`,
    min: ({ min }: { min: number }) => `Use no mínimo ${min} caracteres`,
    max: ({ max }: { max: number }) => `Use no máximo ${max} caracteres`,
    email: 'Informe um e-mail válido',
    url: 'Informe um endereço válido',
    trim: 'Remova os espaços do início e do fim',
    lowercase: 'Use apenas letras minúsculas',
    uppercase: 'Use apenas letras maiúsculas',
    matches: 'Formato inválido'
  },
  number: {
    min: ({ min }: { min: number }) => `O valor mínimo é ${min}`,
    max: ({ max }: { max: number }) => `O valor máximo é ${max}`,
    lessThan: ({ less }: { less: number }) => `Use um valor menor que ${less}`,
    moreThan: ({ more }: { more: number }) => `Use um valor maior que ${more}`,
    positive: 'Use um valor positivo',
    negative: 'Use um valor negativo',
    integer: 'Use um número inteiro'
  },
  date: {
    min: 'Data anterior ao permitido',
    max: 'Data posterior ao permitido'
  },
  array: {
    min: ({ min }: { min: number }) => `Selecione pelo menos ${min}`,
    max: ({ max }: { max: number }) => `Selecione no máximo ${max}`
  }
}

export function applyBrazilianValidationMessages(): void {
  setLocale(PT_BR_LOCALE)
}

export const PASSWORD_MIN_LENGTH = 8

export const emailField = () => string().trim().email('Informe um e-mail válido').required('Informe o e-mail')

export const newPasswordField = () =>
  string().min(PASSWORD_MIN_LENGTH, `A senha precisa ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres`).required('Informe a senha')

export const confirmPasswordField = (field = 'password') =>
  string()
    .oneOf([ref(field)], 'As senhas não são iguais')
    .required('Confirme a senha')
